import breadcrumbs from './Rating_breadcrumbs';
import companies from './Rating_companies';
import org_employees from './Rating_org_employees';
import common_employees from './Rating_common_employees';
import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
    companies,
    org_employees,
    common_employees,
  },
  state: {
    rating_common_employees: {
      content: {
        search    : '',
        pagination: {
          rowsPerPage: 10,
        },
        headers: [
          {text: 'Компания', value: 'name'},
          {text: 'Кол-во курсов', value: 'all_course_count'},
          {text: 'Статус "Новый"', value: 'new_course_count'},
          {
            text       : 'Статус "Идет обучение"',
            value      : '',
            inner_items: [
              {
                text : 'Не просрочен',
                value: 'not_expired_course_history_count',
              },
              {
                text : 'Просрочен',
                value: 'expired_course_history_count',
              },
            ],
          },
          {text: 'Статус "Завершен"', value: 'completed_course_count'},
          {text: 'Ср. балл', value: 'average_users_points'},
          // {
          //   text       : 'Результаты теста',
          //   value      : '',
          //   inner_items: [
          //     {
          //       text : 'Выше порога',
          //       value: 'test_passed',
          //     },
          //     {
          //       text : 'Ниже порога',
          //       value: 'test_not_passed',
          //     },
          //     {
          //       text : 'Ср. балл',
          //       value: 'test_average',
          //     },
          //   ],
          // },
        ],
        body: [
          {
            name                            : 'Отдел по продвижению продуктов и техники', // company_id + completed_course_count + users_count
            all_course_count                : 1254,
            new_course_count                : '456 (45%)',
            not_expired_course_history_count: '156 (25%)',
            expired_course_history_count    : '16 (0,5%)',
            completed_course_count          : '808 (55%)',
            average_users_points            : '84',
          },
        ],
      },
    },
    rating                : [],
    user_rating           : {},
    company_rating        : {},
    user_in_company_rating: {},
    organization_rating   : {},
    company_rating_list   : [],
    loading               : false,
  },
  getters: {
    rating                : ({rating}) => rating,
    user_rating           : ({user_rating}) => user_rating,
    company_rating        : ({company_rating}) => company_rating,
    user_in_company_rating: ({user_in_company_rating}) =>
      user_in_company_rating,
    loading: ({loading}) => loading,
  },
  mutations: {
    SET_RATING(state, value) {
      state.rating = value;
    },
    SET_COMPANY_RATING_LIST(state, value) {
      state.company_rating_list = value;
    },
    SET_ORGANIZATIONS_RATING(state, value) {
      state.organization_rating = value;
    },
    SET_USER_RATING(state, value) {
      state.user_rating = value;
    },
    SET_COMPANY_RATING(state, value) {
      state.company_rating = value;
    },
    SET_USER_IN_COMPANY_RATING(state, value) {
      state.user_in_company_rating = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
  },
  actions: {
    async get_common_rating({commit}, {page = 1, pageSize = 10}) {
      try {
        await commit('SET_LOADING', true);
        let rating = await api.rating.get_common_rating({page, pageSize});
        commit('SET_RATING', rating.data.data);

        await commit('rating/common_employees/SET_EMPLOYEES', rating.data.data, {root: true});
        commit('rating/common_employees/SET_PAGINATION', rating.data.pagination, {root: true});

        if (rating.data.current_user_rating) {
          await commit('rating/common_employees/SET_CURRENT_COMMON_EMPLOYEE_RATING', rating.data.current_user_rating, {root: true});
        }

        await commit('SET_LOADING', true);
      } catch (err) {
        console.error(err);
      }
    },
    async get_org_rating({commit}, {page = 1, pageSize = 10}) {
      try {
        await commit('SET_LOADING', true);
        let rating = await api.rating.get_org_rating({page, pageSize});

        if (page == 1) {
          commit('SET_ORGANIZATIONS_RATING', rating.data.data);
        }

        commit('SET_RATING', rating.data.data);

        await commit('rating/companies/SET_COMPANIES', rating.data.data, {root: true});
        commit('rating/companies/SET_PAGINATION', rating.data.pagination, {root: true});
        await commit('SET_LOADING', true);
      } catch (err) {
        console.error(err);
      }
    },
    async get_internal_rating({commit}) {
      try {
        await commit('SET_LOADING', true);

        let rating = await api.rating.get_internal_rating();
        commit('SET_RATING', rating.data.data);

        await commit('SET_LOADING', false);
      } catch (err) {
        console.error(err);
      }
    },
    async get_employees_rating({commit}, {page = 1, pageSize = 10}) {
      try {
        await commit('SET_LOADING', true);

        let rating = await api.rating.get_employees_rating({page, pageSize});
        commit('SET_RATING', rating.data.data);

        if (page == 1) {
          commit('SET_COMPANY_RATING_LIST', rating.data.data);
        }

        await commit('rating/org_employees/SET_ORG_EMPLOYEES', rating.data.data, {root: true});
        commit('rating/org_employees/SET_PAGINATION', rating.data.pagination, {root: true});

        if (rating.data.current_user_rating) {
          await commit('rating/org_employees/SET_CURRENT_ORG_EMPLOYEE_RATING', rating.data.current_user_rating, {root: true});
        }

        await commit('SET_LOADING', false);
      } catch (err) {
        console.error(err);
      }
    },
    async get_user_rating({commit, rootGetters}, id) {
      // let user = rootGetters['profile/user/user'];
      let storage_user = JSON.parse(localStorage.getItem('user'));

      let user_id = storage_user.id || 0;

      if (id) {
        user_id = id;
      }

      try {
        let rating = await api.rating.get_user_rating(user_id);
        commit('SET_USER_RATING', rating.data);
      } catch (err) {
        console.error(err);
      }
    },
    async get_company_rating({commit, rootGetters}) {
      let storage_user = JSON.parse(localStorage.getItem('user'));
      try {
        let rating = await api.rating.get_company_rating(
            storage_user.company_id
        );
        commit('SET_COMPANY_RATING', rating.data);
      } catch (err) {
        console.error(err);
      }
    },
    async get_user_in_company_rating({commit, rootGetters}, id) {
      let user_id = 0;

      if (id) {
        user_id = id;
      }

      try {
        let rating = await api.rating.get_user_in_company_rating(user_id);
        commit('SET_USER_IN_COMPANY_RATING', rating.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
